import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, ref } from "vue";
import { InstallationSchema } from "@/types";
import { installationsColumns } from "@/util";
import { integrationsApiStore } from "@/hooks";
import { TextButton, SelectorTable, PanelCard } from "@/components/common";
import IntegrationsStepper from "./IntegrationsStepper.vue";


/**
 * Renders a table of all active installations for the current project.
 */
const __default__ = {
  name: "ProjectInstallationsTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const addOpen = ref(false);

const rows = computed(() => integrationsApiStore.installations);

const title = computed(() => (addOpen.value ? "Add Integration" : undefined));

const subtitle = computed(() =>
  addOpen.value ? "Configure a new integration source." : undefined
);

/**
 * Syncs the current project with the selected installation's data.
 * @param installation - THe installation to sync.
 */
function handleSync(installation: InstallationSchema): void {
  integrationsApiStore.handleSync(installation);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    title: title.value,
    subtitle: subtitle.value
  }, {
    "title-actions": _withCtx(() => [
      (addOpen.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            icon: "cancel",
            label: "Cancel",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addOpen.value = false))
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!addOpen.value)
        ? (_openBlock(), _createBlock(_unref(SelectorTable), {
            key: 0,
            addable: "",
            columns: _unref(installationsColumns),
            rows: rows.value,
            "item-name": "integration",
            "row-key": "installationId",
            "onRow:add": _cache[1] || (_cache[1] = ($event: any) => (addOpen.value = true))
          }, {
            "cell-actions": _withCtx(({ row }) => [
              _createVNode(_unref(TextButton), {
                text: "",
                label: "Re-Sync Data",
                color: "primary",
                icon: "sync",
                onClick: ($event: any) => (handleSync(row))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["columns", "rows"]))
        : (_openBlock(), _createBlock(IntegrationsStepper, {
            key: 1,
            type: "connect",
            onSubmit: _cache[2] || (_cache[2] = ($event: any) => (addOpen.value = false))
          }))
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})